import { EntityRawAction } from '../../entity-actions/interfaces/entity-actions';

export enum RecipientActionsType {
  'SWITCH' = 'SWITCH',
  'EDIT' = 'EDIT',
  'DELETE' = 'DELETE',
  'ADD' = 'ADD'
}

export interface Recipient {
  id: string;
  channel_type: string;
  channel_identifier: string;
  added_by: string;
  actions: EntityRawAction<RecipientActionsType>[];
}

export interface SlackChannelPayload {
  type: string;
  channel_identifier: {
    webhook_url_id: number;
    channel_id: string;
    channel_name: string;
  };
}

export interface EmailRecipientPayload {
  type: string;
  channel_identifier: {
    email: string;
  };
}
